export const INITIAL_MACHINERIES_REQUEST = "INITIAL_MACHINERIES_REQUEST";
export const FETCH_MACHINERIES_SUCCESS = "FETCH_MACHINERIES_SUCCESS";
